import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=c556f3de&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
import style0 from "./Table.vue?vue&type=style&index=0&id=c556f3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c556f3de",
  null
  
)

export default component.exports